import ICategory from "../../models/category";
import { host, IRequest } from "./core";

export const buildCategoriesRequest = (): IRequest<ICategory[]> => {
  return {
    url: `${host}/api/categories`,
    options: {
      method: "get",
      resolveWithFullResponse: true,
      json: true
    }
  };
};
